import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';

declare var $;

export interface PopWindowConfig {
  title: string,
  width: number,
  height: number,
  theme: string,
  contentComponent: any
}

export class PopWindow {
  //关闭窗口
  closePopwindow: Function;
  pageParams: any;
}

export interface VisibleChangeEvent {
  visible: boolean;
  reason: any;   //变化原因
}


@Component({
  selector: 'popwindow',
  templateUrl: './popwindow.component.html',
  styleUrls: ['./popwindow.component.less']
})
export class PopwindowComponent implements AfterViewInit {

  private _windowConifg: PopWindowConfig = {
    title: "",
    width: 800,
    height: 600,
    theme: 'theme-white',
    contentComponent: null,  //显示到弹窗上的组件
  }
  @Output() visibleChanged = new EventEmitter<VisibleChangeEvent>();
  //窗口配置
  @Input()
  set windowConfig(config: PopWindowConfig) {
    $.extend(this._windowConifg, config);
  }
  get windowConfig(): PopWindowConfig {
    return this._windowConifg;
  }

  constructor(private element: ElementRef,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  private layer;
  ngAfterViewInit(): void {
    this.layer = $(this.element.nativeElement.querySelector('div.popuplayer'));
    var left = ($(window).width() - this.windowConfig.width) / 2;
    var top = 50;
    this.layer.css({
      "width": this.windowConfig.width + "px",
      "left": left + "px",
      "top": top + "px"
    })
  }

  //创建子组件
  private createChildComponent(params: any) {
    const that = this;
    var contentElement = this.element.nativeElement.querySelector('div.popuplayer-content');
    var factory = this.componentFactoryResolver.resolveComponentFactory(this.windowConfig.contentComponent);
    var popupComponentRef = factory.create(this.injector, [], contentElement);
    var popwindow: PopWindow = popupComponentRef.instance as PopWindow;
    popwindow.pageParams = params;
    popwindow.closePopwindow = function (reason = null) {
      that.setVisible(false, null, reason);
    }
    popupComponentRef.instance["pageParams"] = params;
    this.applicationRef.attachView(popupComponentRef.hostView);
  }
  //设置状态显示
  public setVisible(visible: boolean, params: any = null, changereson = null) {
    var overlayer = this.layer.parent(".popuplayer-overlayer");
    var left = ($(window).width() - this.windowConfig.width) / 2;
    var top = 50;
    if (visible) {
      if (!overlayer.hasClass('hide'))
        return;
      this.createChildComponent(params);
      overlayer.removeClass('hide');
      this.layer.css({
        'opacity': 0,
        "width": this.windowConfig.width + "px",
        "left": left + "px",
        "top": (top - 30) + "px"
      })
      this.layer.animate({
        'opacity': 1,
        'left': left + "px",
        'top': top + "px"
      }, {
        speed: 800
      });
    } else {
      if (overlayer.hasClass('hide'))
        return;
      this.layer.animate({
        'opacity': 0,
        'left': left + "px",
        'top': (top - 20) + "px"
      }, {
        speed: 500,
        done: function () {
          overlayer.addClass('hide');
        }
      });
    }
    this.visibleChanged.emit({
      visible: visible,
      reason: changereson
    });
  }

  /**
   * 使用新的配置打开窗口,新的配置将覆盖原有配置
   * 可以完全替代setVisible开启窗口,也可以动态的修改配置
   * @param params 
   * @param config 
   */
  public openWindow(params: any = null, config: PopWindowConfig = null) {
    if (config != null) {
      this.windowConfig = config;
    }
    this.setVisible(true, params);
  }

}
